import React from 'react'
import { Button, Form, ModalBody, ModalFooter } from 'reactstrap';


export const DeleteIndicationsLab = (props) => {

    const { toggleLab, loading2,indication2,saveDelete2} = props;

    return (
        <Form role="form" onSubmit={ saveDelete2 }>
            <ModalBody>
            <p className="h6 txt-danger">Estas a punto de eliminar la siguiente indicación:</p>  
            <b>{indication2}</b> 
            <p>¿Estás seguro de hacerlo?</p>
            </ModalBody>
            <ModalFooter>
                <Button
                    color="danger"
                    type="submit"
                    className={loading2 ? "disabled progress-bar-animated progress-bar-striped" : ""}
                >
                    Si,eliminar
                </Button>
                <Button color="light" type="button" onClick={toggleLab}>Cancelar</Button>
            </ModalFooter>
        </Form>
    )
}
